import React from 'react';
const OpacityContext = React.createContext(null);
OpacityContext.displayName = 'OpacityContext'; // useful for react dev tools
export default OpacityContext;
